export default __webpack_public_path__ + "static/media/pt-title-en.6c73d72d.webp";